"use strict";

import { c as _c } from "react/compiler-runtime";
import { Box, LoadingBox, useBoxStyles } from '@autoguru/overdrive';
import * as styles from './UserAvatarLoading.css';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
export const UserAvatarLoading = () => {
  const $ = _c(6);
  if ($[0] !== "2b2d25ced3a0c34fdf4ba0457d2078c3e38256eb7226b18e6d011e3a71824108") {
    for (let $i = 0; $i < 6; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "2b2d25ced3a0c34fdf4ba0457d2078c3e38256eb7226b18e6d011e3a71824108";
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      flexShrink: 0,
      borderRadius: "full"
    };
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = useBoxStyles(t0);
  let t2;
  if ($[2] !== t1) {
    t2 = clsx(styles.avatarLoading, t1);
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = /*#__PURE__*/_jsx(Box, {
      "aria-disabled": "true",
      display: "flex",
      alignItems: "center",
      justifyContent: "flexEnd",
      flexShrink: 0,
      paddingY: "6",
      children: /*#__PURE__*/_jsx(LoadingBox, {
        randomWidth: false,
        className: t2
      })
    });
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};